import React from "react";
import {
  Navigation,
  Autoplay,
  Pagination,
  FreeMode,
  Thumbs,
  Zoom,
} from "swiper/modules";
import { useState } from "react";
import "swiper/swiper-bundle.css";

import SwiperCore from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import ProductPrimaryDetails from "./ProductPrimaryDetails";
import SizeButtons from "./SizeButtons";
import Action from "./Action";
import { APP_URL } from "../../shared/constants";
import Counter from "../Counter/Counter";
import { toast } from "react-toastify";
import useReducerHook from "../../hooks/useReducerHook";
import useFindMenuID from "../../hooks/useFindSlug";

SwiperCore.use([Navigation, Autoplay, Pagination, FreeMode, Thumbs, Zoom]);
const QuickView = ({
  productDetailsData,
  loading,
  isWishlistLoading,
  addToCart,
  addToWishList,
  selectedOptions,
  setSelectedOptions,
  quantity,
  setQuantity,
  assetsDetails,
  productVarientsData,
  onChangeVaraiant,
}) => {
  const [selectedImageIndex, setSelectedImageIndex] = useState(0);
  const [thumbsSwiper, setThumbsSwiper] = useState(null);

  const handleThumbnailClick = (index) => {
    setSelectedImageIndex(index);
  };
  function mergedAssets() {
    if (
      assetsDetails?.length >= 0 &&
      Object.keys(productDetailsData)?.length > 0
    ) {
      const assetsDetailsCopy = [...assetsDetails];

      if (
        assetsDetailsCopy?.some(
          (x) => x?.image_path === productDetailsData?.thumnail_image
        )
      ) {
        const targetIndex = assetsDetailsCopy?.findIndex(
          (item) => item.image_path === productDetailsData?.thumnail_image
        );

        if (targetIndex !== -1) {
          const [targetObject] = assetsDetailsCopy.splice(targetIndex, 1);
          assetsDetailsCopy.unshift(targetObject);
        }

        return assetsDetailsCopy;
      } else {
        let data = [
          { image_path: productDetailsData?.thumnail_image },
          ...assetsDetailsCopy,
        ];
        return data;
      }
    }
  }
  // for copy link
  const { pageMenus } = useReducerHook();

  let viewproductID = useFindMenuID(pageMenus?.menuData, "product_details");
  const encodedPageId = btoa(viewproductID?.page_id?.toString());
  const encodedProductId = btoa(productDetailsData?.product_id?.toString());

  let currentLocation = `${window.location.origin}${window.location.pathname}`;

  // const url = `${currentLocation}?${encodedProductId || ""}`;
  const url = `${currentLocation}?${encodedProductId || ""}&${encodedPageId || ""}`;
  const copyToClipboard = (e) => {
    e.preventDefault();
    const input = document.createElement("input");
    input.value = url;
    document.body.appendChild(input);
    input.select();
    document.execCommand("copy");
    document.body.removeChild(input);
    toast.success("Link copied to clipboard!");
  };
  return (
    <div className="container">
      <div className="container">
        <div className="row">
          <div className="col-lg-1 col-md-2 col-sm-3 col-3 p-0 ">
            <Swiper
              onSwiper={setThumbsSwiper}
              slidesPerView={4}
              className="quick-modal-swiper thumb-swiper-lg thumb-sm swiper-vertical"
              spaceBetween={1}
              freeMode={true}
              watchSlidesProgress={true}
              direction="vertical"
              style={{
                width: "100%",
                height: "600px",
                overflowY: "auto",
                scrollbarWidth: "none",
                objectFit: "cover",
              }}
            >
              {mergedAssets()?.length > 0 &&
                mergedAssets()?.map((bannerMedia, index) => (
                  <SwiperSlide
                    key={index}
                    style={{
                      padding: 0,
                      margin: 0,
                      height: "auto",
                      // border:
                      //   selectedImageIndex === index
                      //     ? "2px solid #000000"
                      //     : "none",
                      cursor: "pointer",
                    }}
                    className="m-2"
                    onClick={() => handleThumbnailClick(index)}
                  >
                    <img
                      src={APP_URL + bannerMedia?.image_path}
                      alt={`thumbnail ${index}`}
                      style={{
                        width: "100%",
                        height: "auto",
                        objectFit: "cover",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        borderRadius: "5px",
                      }}
                    />
                  </SwiperSlide>
                ))}
            </Swiper>
          </div>

          <div
            className="col-lg-6 col-md-7 col-sm-7 col-9"
            style={{ zIndex: "1" }}
          >
            <Swiper
              loop={true}
              slidesPerView={1}
              spaceBetween={1}
              navigation={false}
              thumbs={{
                swiper:
                  thumbsSwiper && !thumbsSwiper.destroyed ? thumbsSwiper : null,
              }}
              modules={[FreeMode, Navigation, Thumbs]}
              className="quick-modal-swiper2 my-auto "
            >
              {mergedAssets()?.length > 0 &&
                mergedAssets()?.map((bannerMedia, index) => (
                  <SwiperSlide
                    key={index}
                    className="d-flex justify-content-center align-items-center"
                  >
                    <img
                      src={APP_URL + bannerMedia?.image_path}
                      style={{
                        maxWidth: "90%",
                        height: "auto",
                        objectFit: "contain",
                        borderRadius: "10px",
                      }}
                      alt={`product ${index}`}
                      // className="rounded-25"
                    />
                  </SwiperSlide>
                ))}
            </Swiper>
            {/* </div> */}
          </div>

          <div className="col-xl-5 col-lg-5 col-sm-12 col-md-5 col-12">
            <ProductPrimaryDetails productDetailsData={productDetailsData} />
            <div className="my-4">
              <h6
                style={{
                  color: "#222222",
                  fontWeight: 400,
                }}
              >
                Quantity
              </h6>
              <Counter
                initialValue={quantity}
                minValue={1}
                maxValue={productDetailsData?.quantity}
                onChange={(value) => setQuantity(value)}
              />
            </div>
            <div className="my-4">
              <h6
                style={{
                  color: "#222222",
                  fontWeight: 400,
                }}
              >
                Select Size
              </h6>
              <SizeButtons
                productVarientsData={productVarientsData}
                onChangeVaraiant={onChangeVaraiant}
              />
            </div>
            <Action
              copyToClipboard={copyToClipboard}
              addToCart={addToCart}
              addToWishList={addToWishList}
              isWishlistLoading={isWishlistLoading}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default QuickView;
